import { FormPage } from "app/pages/public/FormPage";
import { FormThankYouPage } from "app/pages/public/FormThankYouPage";
import FacebookCallback from "app/pages/auth/FacebookCallback";
import QRFormPage from "app/pages/public/QrFormPage";

const publicRoutes = {
  id: "public",
  children: [
    {
      path: "/qr/:token",
      Component: QRFormPage,
    },
    {
      path: "/form/:formId",
      Component: FormPage,
    },
    {
      path: "/form-thankyou/:leadId",
      Component: FormThankYouPage,
    },
    {
      path: "/facebook/callback",
      Component: FacebookCallback,
    },
    {
      path: "/privacy",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Privacy")).default,
      }),
    },
    {
      path: "/terms",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Terms")).default,
      }),
    },

  ],
};

export { publicRoutes };
